var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSort24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.902 6.552a.5.5 0 00-.719 0l-2.993 3.1a.5.5 0 10.72.695L8.05 8.13V15a.5.5 0 001 0V8.14l2.141 2.208a.5.5 0 00.718-.696l-3.007-3.1zM15.458 17.6a.5.5 0 01-.36-.152l-3.007-3.1a.5.5 0 11.718-.696l2.141 2.207V9a.5.5 0 011 0v6.87l2.14-2.217a.5.5 0 11.72.694l-2.993 3.1a.5.5 0 01-.36.153z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort24);
export default __webpack_public_path__ + "static/media/icon-sort-24.a3f9fd2e.svg";
export { ForwardRef as ReactComponent };